import { AxiosRequestConfig } from "axios";

import { createApiQueryHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IPage, IPageResource } from "../types";

export type IPageQueryParameters = {
    locale?: string;
    page?: RelationalValue<IPageResource>;
};

export type IPageQueryResult = IPage;

export function pageQuery({ locale, page }: IPageQueryParameters): AxiosRequestConfig | undefined {
    if (!page) {
        return;
    }

    return {
        method: "GET",
        url: `/pages/${mapRelationalValue(page)}`,
        ...(locale ? { headers: { "x-locale": locale } } : {}),
    };
}

export const usePageQuery = createApiQueryHook<IPageQueryParameters, IPageQueryResult>(pageQuery);
